import React, { useEffect, useState } from 'react';
import { TablePagination } from '@mui/material'; // Only importing TablePagination from MUI
import LoaderComponent from '../../components/LoaderComponent/LoaderComponent';
import { getReportData } from '../../services/apiController';
import localDataStorage from '../../store/localDataStorage';
import { useSelector } from 'react-redux';

const inrFormatter = new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

const SummaryReport = () => {
    const eventMasterId = useSelector(state => state.reduxMaster.eventMasterId);

    const [loading, setLoading] = useState(false);
    const [ticketsSummary, setTicketsSummary] = useState([]);
    const [tickets, setTickets] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(10); // Default rows per page
    const [currentPage, setCurrentPage] = useState(1); // Default current page
    const [maxRows, setMaxRows] = useState(0); // Total number of rows
    const [gotoPage, setGotoPage] = useState(1); // Page input for jump
    const [totalPages, setTotalPages] = useState(1); // Total pages calculation
    const [searchQuery, setSearchQuery] = useState(''); // For search query
    const [sortOrder, setSortOrder] = useState({ column: '', order: 'asc' }); // For sorting state

    const [columnCount, setColumnCount] = useState(1);

    useEffect(() => {
        const thCount = document.querySelectorAll('thead th').length;
        setColumnCount(thCount || 1);
    }, []);

    useEffect(() => {
        const reportData = {
            username: localDataStorage.getLocalStorage("username"),
            password: localDataStorage.getLocalStorage("password"),
            ticket_master_id: eventMasterId
        };

        setLoading(true);
        getReportData(reportData).then((response) => {
            if (response.tickets) {
                setTicketsSummary(response.summary);
                setTickets(response.tickets);
                setMaxRows(response.tickets.length); // Set total rows from response
                setTotalPages(Math.ceil(response.tickets.length / rowsPerPage)); // Calculate total pages
            } else {
                // Handle error scenario
            }
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
            // Handle API error
        });
    }, [rowsPerPage, currentPage]); // Re-run the effect when rowsPerPage or currentPage changes

    // Handle page change
    const handleChangePage = (event, newPage) => {
        setCurrentPage(newPage + 1); // MUI TablePagination uses 0-based index
    };

    // Handle rows per page change
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setCurrentPage(1); // Reset to page 1 when rows per page changes
    };

    // Handle page input change
    const handleGotoPageChange = (event) => {
        setGotoPage(event.target.value);
    };

    // Handle the submit (Enter key press) for "Go to page"
    const handleSubmitGotoPage = (event) => {
        if (event.key === 'Enter') {
            const pageNumber = Math.max(1, Math.min(totalPages, parseInt(gotoPage, 10))); // Ensure valid page
            setCurrentPage(pageNumber);
        }
    };

    // Handle search query change
    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    // Filtered and sorted stallList
    const SEARCH_FIELDS = [
        'name',
        'emailId',
        'mobileNo',
        'paymentTransactionId',
        'orderId',
        'ticketPromoCode',
        'ticketCount',
        'totalAmount',
        'entryDateTime'
    ];

    const filteredTickets = tickets.filter((stall) =>
        SEARCH_FIELDS.some((field) =>
            stall[field]
                ?.toString()
                .toLowerCase()
                .includes(searchQuery.toLowerCase())
        )
    );

    // Filtered and sorted tickets
    // const filteredTickets = tickets.filter((ticket) => {
    //     return (
    //         ticket.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //         ticket.emailId.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //         ticket.mobileNo.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //         ticket.paymentTransactionId.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //         ticket.ticketCount.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //         ticket.totalAmount.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //         ticket.entryDateTime.toLowerCase().includes(searchQuery.toLowerCase())
    //     );
    // });

    // Sorting function
    const handleSort = (column) => {
        const newOrder = sortOrder.order === 'asc' ? 'desc' : 'asc';
        setSortOrder({
            column: column,
            order: newOrder,
        });
    };

    const sortedTickets = filteredTickets.sort((a, b) => {
        if (!sortOrder.column) return 0;

        const aValue = a[sortOrder.column];
        const bValue = b[sortOrder.column];

        if (aValue < bValue) return sortOrder.order === 'asc' ? -1 : 1;
        if (aValue > bValue) return sortOrder.order === 'asc' ? 1 : -1;
        return 0;
    });

    return (
        loading ? <LoaderComponent />
            : <React.Fragment>
                <div style={{ padding: '10px 20px', overflowX: 'auto' }}>
                    <h2 className='dialog-heading' style={{ marginBlockEnd: '10px' }}>Summary Report</h2>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th className='tableHeaderStyle'>Ticket Type</th>
                                <th className='tableHeaderStyle'>Applicable Start Date Time</th>
                                <th className='tableHeaderStyle'>Applicable End Date Time</th>
                                <th className='tableHeaderStyle' style={{ textAlign: 'right' }}>Ticket Rate</th>
                                <th className='tableHeaderStyle' style={{ textAlign: 'right' }}>Total Ticket</th>
                                <th className='tableHeaderStyle' style={{ textAlign: 'right' }}>Total Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {ticketsSummary?.map((item, index) => (
                                <tr key={index} style={{ ...tableRowStyle, backgroundColor: index % 2 === 1 ? '#ececec' : '#FFFFFF' }}>
                                    <td className='tableCellStyle'>{item.ticketType == null ? '-' : item.ticketType} {item.ticketPromoCode == null ? "" : `( ${item.ticketPromoCode} )`}</td>
                                    <td className='tableCellStyle'>{item.applicableStartDateTime}</td>
                                    <td className='tableCellStyle'>{item.applicableEndDateTime}</td>
                                    <td className='tableCellStyle' style={{ textAlign: 'right' }}>{inrFormatter.format(item.ticketRate)}</td>
                                    <td className='tableCellStyle' style={{ textAlign: 'right' }}>{item.totalTickets}</td>
                                    <td className='tableCellStyle' style={{ textAlign: 'right' }}>{inrFormatter.format(item.totalAmount)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div style={{ padding: '10px 20px 50px', overflowX: 'auto' }}>
                    <div className='table-heading-search' style={{ marginBottom: '10px' }}>
                        <h2 className='dialog-heading' style={{ marginBlockEnd: '0px' }}>Tickets Entries</h2>

                        {/* Search Input */}
                        <div>
                            Search: <input type="text" value={searchQuery} onChange={handleSearchChange} style={{ padding: '5px', width: '200px', border: '1px solid #ccc', borderRadius: '4px', }} />
                        </div>
                    </div>

                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th className='tableHeaderStyle' onClick={() => handleSort('name')}>Name</th>
                                <th className='tableHeaderStyle' onClick={() => handleSort('emailId')}>E-Mail</th>
                                <th className='tableHeaderStyle' onClick={() => handleSort('mobileNo')}>Mobile No</th>
                                <th className='tableHeaderStyle' onClick={() => handleSort('orderId')}>Order Id</th>
                                <th className='tableHeaderStyle' onClick={() => handleSort('paymentTransactionId')}>Payment Transaction Id</th>
                                <th className='tableHeaderStyle' onClick={() => handleSort('ticketPromoCode')}>Promo Code</th>
                                <th className='tableHeaderStyle' style={{ textAlign: 'right' }} onClick={() => handleSort('ticketCount')}>No. Of Ticket</th>
                                <th className='tableHeaderStyle' style={{ textAlign: 'right' }} onClick={() => handleSort('totalAmount')}>Total Amount</th>
                                <th className='tableHeaderStyle' onClick={() => handleSort('entryDateTime')}>Booking On</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!sortedTickets.length
                                ? <tr>
                                    <td colSpan={columnCount} style={{ textAlign: 'center', padding: '10px', fontSize: '16px' }}>
                                        No Record Found ☹️
                                    </td>
                                </tr>
                                : sortedTickets.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)
                                    .map((ticket, index) => (
                                        <tr key={index} style={{ ...tableRowStyle, backgroundColor: index % 2 === 1 ? '#ececec' : '#FFFFFF' }}>
                                            <td className='tableCellStyle'>{ticket.name}</td>
                                            <td className='tableCellStyle'>{ticket.emailId}</td>
                                            <td className='tableCellStyle'>{ticket.mobileNo}</td>
                                            <td className='tableCellStyle'>{ticket.orderId == null ? '-' : ticket.orderId}</td>
                                            <td className='tableCellStyle'>{ticket.paymentTransactionId == null ? '-' : ticket.paymentTransactionId}</td>
                                            <td className='tableCellStyle'>{ticket.ticketPromoCode == null ? '-' : ticket.ticketPromoCode}</td>
                                            <td className='tableCellStyle' style={{ textAlign: 'right' }}>{ticket.ticketCount}</td>
                                            <td className='tableCellStyle' style={{ textAlign: 'right' }}>{inrFormatter.format(ticket.totalAmount)}</td>
                                            <td className='tableCellStyle'>{ticket.entryDateTime}</td>
                                        </tr>
                                    ))}
                        </tbody>
                    </table>

                    {/* Pagination Controls */}
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', padding: '10px' }}>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 50, 100, 200, 500, 1000]}
                            component="div"
                            count={maxRows}
                            rowsPerPage={rowsPerPage}
                            page={currentPage - 1} // MUI TablePagination uses 0-based index
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            id="page-box"
                        />
                        <div style={{ fontSize: '13px', marginLeft: '10px' }}>
                            Page:
                            <input style={{ width: '50px', border: '1px solid #ccc', borderRadius: '5px', padding: '4px' }} type="number" value={gotoPage} disabled={totalPages <= 1} onChange={handleGotoPageChange} onKeyDown={handleSubmitGotoPage} /> Of {totalPages}
                        </div>
                    </div>
                </div>
            </React.Fragment>
    );
};

const tableRowStyle = {
    borderBottom: '1px solid #eee',
};

export default SummaryReport;
